/**
 * Profile Page
 *
 * @author edmsamuel
 */
import React from 'react'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import ChangePassword from '../components/ChangePassword'
import { buildPath } from '../Routes'
import { Panel } from '../components'
import Page from '../components/View'
import CuentasBancarias from './Com/Components/CuentasBancarias'
import { Row, Col } from 'antd'
import InformacionForm from './Com/Components/InformacionForm'
import Api from '../Api'
import Exception from '../Exception'
import { appAccountLoad } from '../actions/cuenta'

class Perfil extends React.Component {
  state = {
    info: {}
  }

  componentDidMount = async () => {
    try {
      const result = await Api.query({
        __returnType: 'one',
        model: 'ComProveedor',
        attributes: [
          'sRazonSocial',
          'sRfc',
          'sDomicilio',
          'iTipoContrib',
          'sEmail',
        ],
        where: {
          iId: Api.getProviderId(),
        }
      })

      this.setState({ info: result.data })
    } catch (err) {
      Exception.load(err).show()
    }
  }

  /**
   * Render
   */
  render() {
    const cuenta = this.state.info

    return (
      <Page style={{ padding: 50 }}>
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <h1 style={{ marginBottom: 20 }}>Preferencias</h1>

          <Row gutter={8} style={{ marginBottom: 30 }}>
            <Col span={10}>
              <h2>Información general</h2>
              <Panel hoverable onClick={() => this.informacionForm.load()} style={{ cursor: 'pointer' }}>
                <Row>
                  <Col span={24}>
                    <label>RAZON SOCIAL</label>
                    <h3>{cuenta.sRazonSocial}</h3>

                    <label>RFC</label>
                    <h5>{cuenta.sRfc}</h5>

                    <label>DOMICILIO</label>
                    <h5>{cuenta.sDomicilio}</h5>

                    <label>TIPO</label>
                    <h5>{cuenta.iTipoContrib ? 'MORAL' : 'FÍSICA'}</h5>

                    <label>CORREO ELETRÓNICO</label>
                    <h5>{cuenta.sEmail}</h5>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>

          <Row style={{ marginBottom: 30 }}>
            <Col span={24}>
              <h2>Cuentas</h2>
              <CuentasBancarias
                readOnly={this.props.cuenta.needsChangePassword}
              />
            </Col>
          </Row>

          <Row style={{ marginBottom: 30 }}>
            <Col span={10}>
              <h2>Cambiar contraseña</h2>
              <Panel>
                <ChangePassword
                  onUpdateOk={() =>
                    this.props.reloadAccount(() => {
                      this.props.goToNext()
                    })
                  }
                />
              </Panel>
            </Col>
          </Row>
        </div>

        <InformacionForm
          ref={ref => this.informacionForm = ref}
          readOnly={this.props.cuenta.needsChangePassword}
        />
      </Page>
    )
  }
}

export default connect(state => ({
  cuenta: state.cuenta,
}), dispatch => ({
  reloadAccount: (cb) => dispatch(appAccountLoad(cb)),
  goToNext: () => dispatch(push(buildPath('/'))),
}))(Perfil)
